import { render, staticRenderFns } from "./BaiduView.vue?vue&type=template&id=6b807b71&scoped=true&"
import script from "./BaiduView.vue?vue&type=script&lang=js&"
export * from "./BaiduView.vue?vue&type=script&lang=js&"
import style0 from "./BaiduView.vue?vue&type=style&index=0&id=6b807b71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b807b71",
  null
  
)

export default component.exports